import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

/**
 * Shared open-page shell for every unauthenticated route (Home, Login, Register, Contact, etc.) -
 * content sits directly on the page background instead of inside a single bordered Card, so
 * navigating between them doesn't jump from an open landing page to a boxed form. PublicHeader
 * already carries the brand mark, so pages here only need their own title.
 */
function PublicPageLayout({ subtitle, children, colProps = { md: 6, lg: 4 } }) {
  return (
    <div className="d-flex flex-column min-vh-100">
      <PublicHeader />
      <Container className="py-5 flex-grow-1">
        <Row className="justify-content-center">
          <Col {...colProps}>
            {subtitle && <h4 className="text-center mb-4">{subtitle}</h4>}
            {children}
          </Col>
        </Row>
      </Container>
      <PublicFooter />
    </div>
  );
}

export default PublicPageLayout;
